var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"page-container p-3"},[_c('UserCompanyDetailContainer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }